import { render } from "./orgIndex.vue?vue&type=template&id=5b0b9990&scoped=true"
import script from "./orgIndex.vue?vue&type=script&lang=js"
export * from "./orgIndex.vue?vue&type=script&lang=js"

import "./orgIndex.vue?vue&type=style&index=0&id=5b0b9990&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0b9990"]])

export default __exports__